var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "edit-05"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M9.1665 3.33417H5.6665C4.26637 3.33417 3.56631 3.33417 3.03153 3.60666C2.56112 3.84634 2.17867 4.22879 1.93899 4.6992C1.6665 5.23398 1.6665 5.93404 1.6665 7.33417V14.3342C1.6665 15.7343 1.6665 16.4344 1.93899 16.9691C2.17867 17.4396 2.56112 17.822 3.03153 18.0617C3.56631 18.3342 4.26637 18.3342 5.6665 18.3342H12.6665C14.0666 18.3342 14.7667 18.3342 15.3015 18.0617C15.7719 17.822 16.1543 17.4396 16.394 16.9691C16.6665 16.4344 16.6665 15.7343 16.6665 14.3342V10.8342M6.66648 13.3342H8.06193C8.46959 13.3342 8.67341 13.3342 8.86522 13.2881C9.03528 13.2473 9.19786 13.18 9.34698 13.0886C9.51517 12.9855 9.6593 12.8414 9.94755 12.5531L17.9165 4.58417C18.6069 3.89382 18.6069 2.77453 17.9165 2.08417C17.2261 1.39382 16.1069 1.39382 15.4165 2.08417L7.44753 10.0531C7.15928 10.3414 7.01515 10.4855 6.91208 10.6537C6.8207 10.8028 6.75336 10.9654 6.71253 11.1355C6.66648 11.3273 6.66648 11.5311 6.66648 11.9387V13.3342Z",
    stroke: "#111111",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/edit-icon.fca3864f510f390e3abd024c949a4c9e.svg";
export { ForwardRef as ReactComponent };